/*******************************************************************************
 * Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc., and its use or disclosure in whole or in
 *                 part without express written permission of Honeywell Inc.
 *                 is prohibited.
 *
 * Name          : BreadcrumbComponent.tsx
 *
 * Project Title : Checkout
 *
 * Description   : Initial version
 *
 * Company       : Honeywell Technology Solutions , Hyderabad
 *
 * @Author       : H422335
 *
 * @Date         : Sep 07, 2020
 *
 * @Version      : Version 1.0
 *
 ******************************************************************************/

import React from 'react';
import { useHistory } from 'react-router-dom';
import { Breadcrumb } from '@scuf/common';
import {
  IBreadcrumbNavObj,
  IBreadcrumbProps
} from '../utils/checkout-interfaces';
import RouteConstants from '../constants/route-constants';
import RouteNames from '../constants/route-names';

function BreadcrumbComponent(props: IBreadcrumbProps) {
  let { breadcrumbs } = props;
  let history = useHistory();
  let breadcrumbNavList = createBreadcrumbNavList(breadcrumbs);
  return (
    <Breadcrumb>
      {breadcrumbNavList.map(item => {
        return item.navigate ? (
          <Breadcrumb.Item
            key={item.pageToNavigateTo}
            onClick={() => item.navigate && item.navigate(history)}
          >
            {item.pageToNavigateTo}
          </Breadcrumb.Item>
        ) : (
          <Breadcrumb.Item key={item.pageToNavigateTo}>
            {item.pageToNavigateTo}
          </Breadcrumb.Item>
        );
      })}
    </Breadcrumb>
  );
}

function createBreadcrumbNavList(breadcrumbs): Array<IBreadcrumbNavObj> {
  let breadcrumbNavList: Array<IBreadcrumbNavObj> = [];

  breadcrumbNavList = breadcrumbs.map((item, index, crumbs) => {
    let navObj: IBreadcrumbNavObj = { pageToNavigateTo: item.location };
    if (index !== crumbs.length - 1) {
      switch (item.location) {
        case RouteNames.MY_CART: {
          navObj.navigate = goToViewCart;
          break;
        }
        case RouteNames.SHIPPING_BILLING: {
          navObj.navigate = goToShippingBillingPage;
          break;
        }
        case RouteNames.PURCHASE_SOFTWARE: {
          navObj.navigate = goToProductListing;
          break;
        }
        case RouteNames.REVIEW_ORDER: {
          navObj.navigate = goToReviewOrderPage;
          break;
        }
        default:
          break;
      }
    }
    return navObj;
  });

  return breadcrumbNavList;
}

function goToShippingBillingPage(browserHistory): void {
  browserHistory.push(RouteConstants.SHIPPING_BILLING);
}

function goToViewCart(browserHistory): void {
  browserHistory.push(RouteConstants.MY_CART);
}

function goToProductListing(browserHistory): void {
  browserHistory.push(RouteConstants.PURCHASE_SOFTWARE);
}

function goToReviewOrderPage(browserHistory): void {
  browserHistory.push({
    pathname: RouteConstants.REVIEW_ORDER,
    state: { status: 'allow' }
  });
}
export default BreadcrumbComponent;
